import { Box, type BoxProps, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { InputSearch } from '@flecto/ui'

import { useProductListFilters } from './useProductListFilters'

export function FilterContent(props: BoxProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  const { filters, setFilter } = useProductListFilters()

  return (
    <Box {...props}>
      <Text fw={500} mb='xs'>
        {t('label_content')}
      </Text>
      <InputSearch
        placeholder={t('label_name_description')}
        size='sm'
        value={filters.q}
        onChange={(value) => setFilter('q', value)}
        withIconSearch={false}
      />
    </Box>
  )
}
